export default __webpack_public_path__ + "static/media/chip_1.4d3d4f8c.svg";